import { Assignment as AssignmentIcon } from '@mui/icons-material';

const Assignment = (): JSX.Element => <AssignmentIcon fontSize="inherit" />;

export default Assignment;
